import { z } from 'zod'
import { EMAIL, NAME, password_error, required_error } from './common'

export const AccountSignInSchema = z.object({
  email: EMAIL,
  password: z.string({ required_error }),
})

export const AccountSignUpSchema = z
  .object({
    name: NAME,
    email: EMAIL,
    password: z.string({ required_error }),
    confirm: z.string({ required_error }),
  })
  .refine((data) => data.password === data.confirm, {
    message: 'Senha e confirmação não conferem',
    path: ['confirm'],
  })

export const AccountForgotPasswordSchema = z.object({
  email: EMAIL,
})

export const AccountPasswordRecevorySchema = z
  .object({
    password: z
      .string({ required_error })
      .trim()
      .min(6, { message: password_error }),
    confirm: z.string({ required_error }).trim(),
  })
  .refine((data) => data.password === data.confirm, {
    message: 'Senha e confirmação não conferem',
    path: ['confirm'],
  })
